import { useMemo } from 'react';

import { SOUNDS } from '~/constants/sounds';
import {
  OrganizationContactPoint,
  OrganizationNotificationSettingDataFragment,
} from '~/graphql/generated/graphql';
import { getWorkPhone } from '~/utils/contact_points';

import { Fields } from './types';

export const useDefaultValues = (
  isLightPlan: boolean,
  organizationContactPoints: OrganizationContactPoint[],
  setting?: OrganizationNotificationSettingDataFragment,
) => {
  const defaultValues = useMemo(() => {
    const _defaultValues: Fields = {
      sound: { name: 'sound1', interval: '' },
      tel: { enable: 'disabled', phoneNumber: '', delay: 5 },
      medicationFollowup: 'disabled',
      online: 'disabled',
    };

    if (setting) {
      _defaultValues.sound = {
        name: setting.sound.name as keyof typeof SOUNDS,
        interval: (setting.sound.interval || '') as Fields['sound']['interval'],
      };
      _defaultValues.tel = {
        enable: setting.tel.enable ? 'enabled' : 'disabled',
        phoneNumber: setting.tel.formattedPhoneNumber || '',
        delay: setting.tel.delay,
      };
      _defaultValues.medicationFollowup = setting.medicationFollowupEnabled
        ? 'enabled'
        : 'disabled';
      _defaultValues.online = setting.onlineEnabled ? 'enabled' : 'disabled';
    }

    if (isLightPlan) {
      _defaultValues.medicationFollowup = 'disabled';

      if (!setting?.tel.enable) {
        const phoneNumber = organizationContactPoints
          ? getWorkPhone(organizationContactPoints)
          : null;

        _defaultValues.tel = {
          enable: 'enabled',
          phoneNumber: phoneNumber || '',
          delay: 5,
        };
      }
    }

    return _defaultValues;
  }, [isLightPlan, organizationContactPoints, setting]);

  return defaultValues;
};
